import { DetailPageLayout } from '@app/DetailPageLayout';

export const AdminEmptyPage = () => {
  return (
    <DetailPageLayout
      errorGetDetail={null}
      isDrawer={false}
      isRestricted={false}
      data="placeholder"
      isLoading={false}
      isRefetching={false}
      title="Admin"
      render={() => {
        return <></>;
      }}
    />
  );
};
